import { LinearProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDataGrid } from "@refinedev/mui";
import { useMemo } from "react";
import { useGetLocale } from "@refinedev/core";
import { trTR, enUS } from "@mui/x-data-grid/locales";
import { useStore } from "zustand";
import { useTranslation } from "../../../hooks/useTranslation";
import { FilterProvider } from "../../../components/dataGridFilter/filter-context/FilterProvider";
import { getQueryFromFilter } from "../../../components/dataGridFilter/getQueryFromFilter";
import { SearchIndicators } from "../../../components/dataGridFilter/SearchIndicators";
import { getOrderListColumns } from "../orderListColumns";
import { FilterValue, getOrderFilterStore } from "../utils/getOrderFilterStore";
import { OrderListFilterRow } from "./OrderListFilterRow";

export const OrderTab = ({ filterValue }: { filterValue: FilterValue }) => {
  const { translate } = useTranslation("pages.orders");
  const locale = useGetLocale();
  const currentLocale = locale();

  const filterStore = getOrderFilterStore(filterValue);
  const filterStatus = useStore(filterStore);
  const query = useMemo(
    () => getQueryFromFilter(filterStatus.filters),
    [filterStatus.filters, getQueryFromFilter]
  );

  const {
    dataGridProps,
    tableQuery: { isInitialLoading },
  } = useDataGrid({
    resource: `orders`,
    sorters: { initial: [{ field: "orderDate", order: "desc" }] },
    meta: {
      queries: query,
    },
  });

  const columns = useMemo(
    () => getOrderListColumns(translate, currentLocale),
    [translate, currentLocale]
  );

  if (isInitialLoading) {
    return <LinearProgress />;
  }

  return (
    <FilterProvider filterStore={filterStore}>
      <OrderListFilterRow />
      <SearchIndicators />
      <DataGrid
        {...dataGridProps}
        rowHeight={96}
        columns={columns}
        sx={{}}
        localeText={
          (currentLocale === "tr" ? trTR : enUS).components.MuiDataGrid
            .defaultProps.localeText
        }
        disableColumnFilter
        keepNonExistentRowsSelected
        hideFooterSelectedRowCount
      />
    </FilterProvider>
  );
};
